import { StudyFilterName } from '../types/Filter';

export const MAX_HISTORY_PATIENT_STUDIES = 11;
/**
 * Filter keys that are specific to the study organization
 */
export const STUDY_ORGANIZATION_SPECIFIC_FILTER_KEYS = [StudyFilterName.rightPossession];
